import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21684 22317"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#2b2a29;stroke-width:246.81}.fil0,.fil1{fill:#2b2a29}.fil1{fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m10843 2231-9341 8934c-176 168-388 321-642 321-252 0-447-149-604-330l-133-153v-523l136-154c16-18 32-35 47-53 81-94 163-186 252-272 3026-2897 6052-5793 9071-8680 271-271 564-547 845-808l369-344 386 360c3338 3192 6648 6414 10012 9578l23 22c50 47 98 94 140 149 231 302 205 718-66 986-139 138-325 218-521 218-161 0-314-53-442-149-84-62-158-134-233-207-17-17-34-33-52-50l-9247-8845zM16855 2274l-1427 1c-301 0-602 0-902-2-467-1-830-287-835-769-2-207 69-404 215-552 162-164 385-235 611-236 483 0 965-1 1448-1l2459 1v1278c0 845 0 1690-1 2536-1 135-8 268-52 397-112 327-387 520-732 520-343 0-618-191-730-516-45-131-52-263-53-399-1-597-1-1195-1-1792v-466z"
        className="fil0"
      />
      <path
        d="M3294 20044h8190l-796 1566H1746l-1-9494c0-53-1-106 3-159 29-410 356-735 784-735 411 9 731 326 758 734 4 65 4 129 4 194v7894z"
        className="fil0 "
      />
      <path
        d="M17125 15211c-233 745-262 1477 193 2188 695 1091 1376 2191 2042 3301 118 196 191 460 178 686-25 393-274 659-664 768-404 112-744-13-986-338-297-399-562-821-838-1236-842-1265-1678-2535-2528-3796-128-190-156-363-104-581 146-615 276-1235 411-1853 12-52 11-106 20-210-239 186-449 341-646 509-47 39-64 125-74 192-68 448-119 898-198 1343-84 476-480 717-946 596-342-88-579-366-531-717 93-690 221-1375 348-2059 17-85 105-167 178-229 711-603 1415-1217 2147-1793 199-157 480-238 737-287 253-47 523-13 785-8 469 9 785 242 957 671 256 638 498 1282 768 1913 60 141 193 279 328 356 385 217 790 398 1185 601 412 211 564 596 390 966-178 378-595 513-1015 314-571-271-1147-537-1703-839-174-96-289-300-434-458z"
        className="fil1 "
      />
      <path
        d="M12642 22034c-804 7-1232-719-888-1338 194-350 415-686 626-1027 507-825 1015-1649 1523-2473 189-305 266-305 469 2 265 400 523 805 795 1200 96 141 110 252 10 401-626 925-1242 1856-1863 2784-185 277-436 446-672 451zM16560 11219c-626 3-1144-512-1143-1134 1-610 517-1129 1126-1132 623-4 1142 514 1141 1137-1 615-510 1126-1124 1129z"
        className="fil1 "
      />
    </g>
  </svg>
);
export default SvgComponent;
